export default function (cli) {
  return {
    adminGroupList () {
      return cli.get(`${cli.adminApiEndpoint}groups/`)
    },

    all (fn) {
      let groups = []
      let request = url => {
        return cli.get(url).then(res => {
          groups = groups.concat(res.body.results)
          if (res.body.next) {
            return request(res.body.next)
          } else {
            return groups
          }
        })
      }
      return request(`${cli.adminApiEndpoint}groups/`).then(fn)
    },

    detail (groupPk) {
      return cli.get(`${cli.apiEndpoint}groups/${groupPk}/`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/groups.js